/**
 * @generated SignedSource<<4cd05d32a30c7fdd289cea058f9be89b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useRecurringRequestSeriesPreview_booking$data = {
  readonly id: string;
  readonly " $fragmentType": "useRecurringRequestSeriesPreview_booking";
};
export type useRecurringRequestSeriesPreview_booking$key = {
  readonly " $data"?: useRecurringRequestSeriesPreview_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRecurringRequestSeriesPreview_booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRecurringRequestSeriesPreview_booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "e6dfe79fc723549b391281824fabcfd6";

export default node;
